import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PrepareGuard, AuthGuard } from 'app/core/core.module';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { AttachmentOverviewComponent } from 'app/executive/attachment-overview/attachment-overview.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'committees',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'list', pathMatch: 'full' },
                    {
                        path: 'documents',
                        component: AttachmentOverviewComponent,
                        data: { title: 'Documents' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                ],
            },
        ]),
    ],
    declarations: [],
    exports: [],
})
export class CommitteesModule {}
